import React from 'react';
export function Testimonials() {
  const testimonials = [{
    text: 'En 60 días pasé de cero a $1.800.000/mes con Meta Ads. El Blueprint fue exactamente lo que necesitaba. Sin pérdidas de dinero.',
    author: '— Lucía M., Flores, CABA'
  }, {
    text: 'El Copy Swipe File me ahorró meses de bloqueo creativo. Simplemente adapté los ángulos a mi producto. ROAS 4.5:1 en 3 semanas.',
    author: '— Martín R., Rosario'
  }, {
    text: 'Había tirado $900.000 ARS en ads que no funcionaban. Con esto entendí qué estaba mal. Ahora gano consistentemente $1.200.000/semana.',
    author: '— Andrea G., La Plata'
  }];
  return <section className="py-16 px-4" data-id="element-90">
      <div className="max-w-[1200px] mx-auto bg-[#00d4ff]/[0.02] rounded-xl py-16 px-6 md:px-12" data-id="element-91">
        <h2 className="text-3xl md:text-[2rem] font-bold text-[#00d4ff] text-center mb-16 uppercase" data-id="element-92">
          LO QUE DICEN NUESTROS CLIENTES
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-93">
          {testimonials.map((t, idx) => <div key={idx} className="relative bg-[#1a1a2e]/80 border border-[#00d4ff]/20 rounded-xl p-8 pt-10" data-id="element-94">
              {/* Large Quote Mark */}
              <div className="absolute -top-4 left-4 text-6xl text-[#00d4ff] opacity-30 font-serif leading-none" data-id="element-95">
                "
              </div>

              <p className="text-[0.95rem] italic text-[#e0e0e0] leading-relaxed mb-6 relative z-10" data-id="element-96">
                {t.text}
              </p>

              <p className="text-[0.9rem] font-bold text-[#00d4ff]" data-id="element-97">
                {t.author}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}